import { useState } from 'react';
import styled from '@emotion/styled';
import H1 from '@base/H1/H1';
import P1 from '@base/P1/P1';
import Logo from '@comp/Logo/Logo';
import Paper from '@base/Paper/Paper';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import AboutUnacademy from '@comp/AboutUnacademy/AboutUnacademy';
import Form from './Form';
import Result from './Result';
import { PREDICTOR_POINTS as POINTS } from './constants';

const Wrapper = styled.div`
  padding-bottom: 120px;
  padding-left: 13vw;
  padding-right: 13vw;
  display: flex;
  justify-content: space-between;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(229, 244, 255, 0.44) 100%
  );

  ${mediaQuery.uptoTablet} {
    padding-left: 10vw;
    padding-right: 10vw;
  }

  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    padding: 0px;
  }
`;

const Header = styled.div`
  height: ${Spacings.SPACING_HEADER}px;
  padding-left: 13vw;
  padding-right: 13vw;
  display: flex;

  ${mediaQuery.uptoTablet} {
    padding-left: 10vw;
    padding-right: 10vw;
  }

  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B};
  }
`;

const Heading = styled(H1)`
  font-size: ${Fonts.LARGE_HEADING};
  margin-top: ${Spacings.SPACING_10B};
  margin-bottom: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H2};
    margin-top: ${Spacings.SPACING_0B};
    margin-bottom: ${Spacings.SPACING_5B};
  }
`;

const LeftWrapper = styled.div`
  width: 50%;
  margin-top: ${Spacings.SPACING_13B};

  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
    margin-top: ${Spacings.SPACING_0B};
    padding-bottom: 0px;
  }
`;

const Point = styled(P1)`
  display: flex;
  align-items: center;
  font-size: ${Fonts.LARGE};
  margin-bottom: ${Spacings.SPACING_4B};

  span {
    margin-left: ${Spacings.SPACING_2B};
    font-size: ${Fonts.SMALL};
  }
  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_3B};
  }
`;

const MainImage = styled.img`
  height: ${Spacings.SPACING_35B};
  width: ${Spacings.SPACING_35B};

  ${mediaQuery.uptoMobile} {
    float: right;
    height: ${Spacings.SPACING_20B};
    width: ${Spacings.SPACING_20B};
  }
`;

const CheckedImage = styled.img`
  height: ${Spacings.SPACING_4B};
  width: ${Spacings.SPACING_4B};
`;

const RightWrapper = styled(Paper)`
  width: 45%;
  height: auto;

  ${mediaQuery.uptoTablet} {
    width: 100%;
    height: auto;
    box-shadow: none;
    padding: ${Spacings.SPACING_4B};
    padding-top: ${Spacings.SPACING_9B};
  }
`;

const RankPredictor = () => {
  const [showResult, setShowResult] = useState(false);
  const [predictedPercentile, setPredictedPercentile] = useState();
  return (
    <>
      <Header>
        <Logo />
      </Header>
      <Wrapper>
        <LeftWrapper>
          <MainImage
            src={getImage('rankpredictor/rank-predictor-logo.svg')}
            alt="rank-main-logo"
          />
          <Heading>CAT Percentile Calculator 2025</Heading>
          {POINTS.map((point, index) => (
            <Point key={String(index)}>
              <CheckedImage
                src={getImage('rankpredictor/checked.svg')}
                alt="checked"
              />
              <span>{point}</span>
            </Point>
          ))}
        </LeftWrapper>
        <RightWrapper $large={showResult}>
          {showResult ? (
            <Result
              predictedPercentile={predictedPercentile}
              setShowResult={setShowResult}
              setPredictedPercentile={setPredictedPercentile}
            />
          ) : (
            <Form
              setShowResult={setShowResult}
              setPredictedPercentile={setPredictedPercentile}
              predictedPercentile={predictedPercentile}
            />
          )}
        </RightWrapper>
      </Wrapper>
      <AboutUnacademy />
    </>
  );
};

export default RankPredictor;
